<template>
  <div id="app">
    <!-- Global Page Loader -->
    <PageLoader />
    <router-view />
    <!-- PWA Install Prompt -->
    <PWAInstallPrompt />
  </div>
</template>

<script setup lang="ts">
import { useTitle } from '@/composables/ui/useTitle'
import { useColorScheme } from '@/composables/ui/useColorScheme'
import { computed } from 'vue'
import PageLoader from '@/components/common/PageLoader.vue'
import PWAInstallPrompt from '@/components/PWAInstallPrompt.vue'

const appTitle = computed(() => process.env.VUE_APP_TITLE || 'Jeducare')
useTitle(appTitle.value)

useColorScheme()
</script>

<style>
/* Global styles */
html {
  font-family: var(--priFont);
}

body {
  font-family: var(--priFont);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Dark mode styles */
.dark {
  color-scheme: dark;
}

/* Color scheme transitions */
* {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
</style> 